var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":require("@/assets/images/Clap.svg"),"alt":"Thank you for your participation","width":(_vm.width + "px")}})}
var staticRenderFns = []

export { render, staticRenderFns }